<template lang="pug">
    article#egressosDesenvolvimentoDeCarreira
        Banner
        Menu(:menu="menu")
        Conteudo(:conteudo="pagina.secoes[0].conteudo", v-if="pagina.secoes")
        Empregabilidade(:conteudo="pagina.secoes[1]")
        Curriculo(:conteudo="pagina.secoes[2]")
</template>

<script>
import pagina from '@/mixins/pagina'
import Banner from '@components/BannerEgressos/BannerEgressos'
import Menu from '@components/MenuEgressos/MenuEgressos'
import Conteudo from '@components/ConteudoEgressos/ConteudoEgressos'
import Curriculo from '@sections/EgressosDesenvolvimentoDeCarreira/Curriculo/Curriculo.vue'
import Empregabilidade from '@sections/EgressosDesenvolvimentoDeCarreira/Empregabilidade/Empregabilidade.vue'

export default {
    name: "view-egressos-desenvolvimento-de-carreira",
    components: {
        Banner,
        Menu,
        Conteudo,
        Curriculo,
        Empregabilidade
    },
    mixins: [
        pagina
    ],
}
</script>

<style lang="stylus" scoped src="./EgressosDesenvolvimentoDeCarreira.styl"></style>